import React, { useState } from 'react';

import Delete from 'components/Common/Icons/Delete';
import ModalDeleteProduct from 'components/Modals/ModalDeleteProduct/ModalDeleteProduct';
import Button from 'components/UI/Buttons/Button/Button';
import { CartProduct as CartProductType } from 'types/Cart';

import styles from './CartProductDelete.module.scss';

export default function CartProductDelete({
  modelName,
  onDelete,
}: CartProductDeleteType): JSX.Element {
  const [isOpenModal, setOpenModal] = useState(false);

  return (
    <>
      <Button
        className={styles.button}
        type={'button'}
        onClick={() => setOpenModal(true)}
      >
        <Delete className={styles.icon} />
      </Button>
      <ModalDeleteProduct
        isOpen={isOpenModal}
        closeModal={() => setOpenModal(false)}
        modelName={modelName}
        deleteProduct={onDelete}
      />
    </>
  );
}

type CartProductDeleteType = Pick<CartProductType, 'modelName'> & {
  onDelete: () => void;
};
